<!-- Encabezado del Modal (solo si el status es 1) -->
<div class="modal-title d-flex justify-content-between" *ngIf="dataRecieved.status == 1">
  <!-- Skeleton Loader (efecto de carga) -->
  <div class="vw-auto-modal align-items-center">
    <ngx-skeleton-loader 
      count="1" 
      appearance="line" 
      [theme]="{
        width: '100%',
        'border-radius': '8',
        height: '8px',
        'margin-bottom': '0px',
        display: 'flex',
        'align-items': 'center'
      }">
    </ngx-skeleton-loader>
  </div>

  <!-- Botón de cierre -->
  <div class="button-x justify-content-end d-flex">
    <img
      class="cursor-pointer pr-4"
      src="assets/image/modal/close-modal.svg"
      alt="Cerrar"
      width="19px"
      (click)="exit()"
    />
  </div>
</div>

<!-- Línea divisoria (solo si el status es 1) -->
<hr class="dividing-line-solid my-3" *ngIf="dataRecieved.status == 1" />

<!-- Contenedor general del modal -->
<div
  class="container-modal d-flex align-items-center justify-content-center"
  [ngClass]="dataRecieved.status == 1 ? 'max-size' : 'charging-modal-size'"
>
  <div>
    <!-- Spinner de carga centrado -->
    <div class="img-modal d-flex justify-content-center">
      <div class="spinner-custom"></div>
    </div>

    <!-- Mensaje dinámico del modal -->
    <div class="message">
      <h1 [innerHTML]="modals[dataRecieved.status].title"></h1>
      <p [innerHTML]="modals[dataRecieved.status].description"></p>
    </div>
  </div>
</div>
